import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-modals-confirm-card',
  templateUrl: './modals-confirm-card.component.html',
  styleUrls: ['./modals-confirm-card.component.css']
})
export class ModalsConfirmCardComponent  {
  bodyTranslation: string
  constructor( public dialogRef: MatDialogRef<ModalsConfirmCardComponent>, private translate: TranslateService) { }

  Accept(){
    this.dialogRef.close(true);
  }
  Close(){
    this.dialogRef.close(false);
  }
  ngOnInit(){

  }

}
